<div
  #toastElement
  aria-atomic="true"
  aria-live="assertive"
  class="d-flex justify-content-between position-relative px-6 py-3 bn-toast {{ type ? 'bn-context--' + type : '' }} fade {{ customClass }}"
  role="alert"
  [ngClass]="type"
  (click)="onToastClick()"
  (focusin)="onMouseEnter()"
  (focusout)="onMouseLeave()"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <span class="w-100">
    <div class="bn-toast__header {{ type ? 'bn-toast__header--' + type : '' }}">
      @if (config.showIcon && headerIcon) {
        <fa-icon
          class="bn-toast__header__icon {{ headerIconStyle ? 'bn-context__text--' + headerIconStyle : '' }} {{ type ? 'bn-toast__header__icon--' + type : '' }}"
          [icon]="headerIcon" />
      }
      @if (config.showClose) {
        <fa-icon
          aria-label="Close"
          class="toast-btn-close"
          icon="xmark"
          (click)="hide()" />
      }
      {{ title }}
    </div>
    <div class="bn-toast__body {{ type ? 'bn-toast__body--' + type : '' }}">
      <ng-content />
    </div>
    @if (externalLink) {
      <div class="bn-toast__ext-link">
        @let icon = externalLink.icon;
        <a
          class="bn-link__bold"
          [href]="externalLink.url"
          [target]="externalLink.target"
          >{{ externalLink.name }}
          @if (icon) {
            <fa-icon [icon]="icon" />
          }
        </a>
      </div>
    }
  </span>
  <span>
    <ng-content select="[content-after]" />
  </span>
</div>
